<template>
  <div>
    <p>Uspesna akcija!</p>

    <div class="footer">
      <button
        type="submit"
        class="btn btn-danger btn--mod"
        @click="closeModal"
      >
        OK
      </button>

    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations('modal', ['closeModal'])
  }
};
</script>

<style scoped>
</style>
